import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { ColorModeScript } from '@chakra-ui/react';
import { SiteProvider } from './context/Site.context';
import theme from './theme/ChakraTheme';
import App from './components/App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLDivElement
);

root.render(
  <ChakraProvider theme={theme}>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <React.StrictMode>
      <Router>
        <SiteProvider>
          <App />
        </SiteProvider>
      </Router>
    </React.StrictMode>
  </ChakraProvider>
);
